/*global _ */
import RocketEffect from './webpack/rocket-effect-loader'

const {addiesaas, vuestrap, EventBus} = RocketEffect

const debugLog = (...args) => {
  const notProd = addiesaas.config.env !== 'production'
  const debug = addiesaas.config.debug
  if ((!notProd && debug === true) || (debug !== false && notProd)) {
    console.log(...args)
  }
}
addiesaas.init = async (el) => {

  EventBus.$emit('addiesaas.app.beforeInit', el, addiesaas, RocketEffect)

  if (!vuestrap.store.getters.authCheck && vuestrap.store.getters.authToken) {
    try {
      await vuestrap.store.dispatch('fetchUser')
    } catch (e) {
    }
  }

  vuestrap.el = el
  const VueApp = new Vue(vuestrap)

  RocketEffect.apps = [...RocketEffect.apps || [], VueApp]

  if (addiesaas.config.env !== 'production') {
    window.RocketEffect = window.RocketEffect || RocketEffect
  }

  EventBus.$emit('addiesaas.app.init', VueApp, addiesaas, RocketEffect)

  return VueApp
}

EventBus.$emit('addiesaas.beforeInit', addiesaas, RocketEffect)

const readyCallbacks = addiesaas.ready && addiesaas.ready.callbacks || []
addiesaas.ready = callbacks => {
  if (!callbacks && readyCallbacks.length) {
    callbacks = readyCallbacks
    debugLog('AddieSaaS Ready running cashed callbacks.', {callbacks, RocketEffect})
  } else if (callbacks) {
    debugLog('AddieSaaS Ready', {callbacks, RocketEffect})
  }

  if (_.isFunction(callbacks)) {
    return callbacks.call(RocketEffect)
  } else if (_.isArray(callbacks)) {
    let callback = null
    while( (callback = callbacks.shift()) !== undefined ) {
      addiesaas.ready(callback)
    }
  }
}
addiesaas.ready()

export default RocketEffect
